import { useQueryClient } from 'react-query'
import { useReplie, useCommentsKey } from 'querys/comments'
import { useDeleteComment, useReactToComment } from 'mutations/comments'
import useSession from 'querys/session'
import CommonDetail from './comment-common-detail'

function ReplyDetail({ parent, uuid, participants }) {
  const data = useReplie(parent, uuid)
  const { mutate } = useDeleteComment()
  const queryClient = useQueryClient()
  const COMMNETS_KEY = useCommentsKey()
  const { mutate: reactToCommentMuration } = useReactToComment()
  const { token } = useSession()
  const deleteReply = (deleted) => {
    mutate(deleted)
    queryClient.setQueryData(['GET_COMMENT_REPLIES', parent], (replies) => (
      replies.filter(({ uuid: replyID }) => (replyID !== deleted))
    ))
    queryClient.setQueryData(COMMNETS_KEY, (comments) => (
      {
        ...comments,
        results: comments.results.map((parentComment) => {
          if (parentComment.uuid === parent) {
            return {
              ...parentComment,
              has_replies: !(parentComment.replies_count - 1 === 0),
              replies_count: parentComment.replies_count - 1,
            }
          }
          return parentComment
        }),
      }
    ))
  }
  const reactToComment = (reaction, reactionCounter) => {
    if (!token) return
    // THE ACTUAL REACTION IS:
    const active = data.reactions[reaction]

    // THE DESIRE ACTION IS: !active
    const newReactions = { ...data.reactions, [reaction]: !active }
    const payload = {
      ...newReactions,
      comment: uuid,
    }
    reactToCommentMuration({ payload })
    queryClient.setQueryData(['GET_COMMENT_REPLIES', parent], (replies) => (
      replies.map((comment) => {
        if (comment.uuid === uuid) {
          return {
            ...comment,
            reactions: newReactions,
            [reactionCounter]: !active ? comment[reactionCounter] + 1 : comment[reactionCounter] - 1,
          }
        }
        return comment
      })
    ))
  }
  if (!data) return null

  return (
    <CommonDetail
      {...data}
      isReply
      onDelete={deleteReply}
      onReaction={reactToComment}
      participants={participants}
    />
  )
}

export default ReplyDetail
